import { withInstall } from '@xzx-design/utils'
import _Overlay from './src/overlay'

export const Overlay = withInstall(_Overlay)
export default Overlay

export * from './src/overlay'
